import { path, contains, pipe, find, toPairs, pathOr } from 'ramda';

export const getExtension = (state, idOrRoute) => (
  path(['extensions', 'byId', idOrRoute], state) ||
  path(['extensions', 'byRoute', idOrRoute], state)
);

export const getExtensionByShopId = (state, shopId) => (
  pipe(
    pathOr({}, ['extensions', 'byId']),
    toPairs,
    find(([, extension]) => (extension.shops && extension.shops.includes(shopId))),
    pathOr(null, [1]),
  )(state)
);

export const isLoading = path(['extensions', 'busy']);
export const getLoadingList = path(['extensions', 'loadingList']);
export const isExtensionLoading = (state, idOrRoute) => pipe(getLoadingList, contains(idOrRoute))(state);



// WEBPACK FOOTER //
// ./src/app/extensions/selectors.js